"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "NumberSign___StyledSvg",
  componentId: "sc-1achi6t-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function NumberSign(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M301.775 326.022L277.09 450H253.29c-4.505 0-8.325-1.66-11.46-4.983-3.134-3.321-4.701-7.62-4.701-12.896 0-.781.048-1.514.146-2.198.098-.684.245-1.514.441-2.491l20.864-101.41h-72.582L165.134 430.07c-1.567 7.23-4.555 12.358-8.963 15.387-4.407 3.029-9.452 4.543-15.133 4.543h-23.214L142.8 326.022H99.9c-4.506 0-8.032-1.123-10.579-3.37-2.547-2.247-3.82-6.106-3.82-11.577a43.11 43.11 0 01.588-6.741l2.35-16.707h59.946l19.1-95.547H99.312l3.82-21.69c.98-5.666 3.232-9.867 6.759-12.602 3.526-2.736 9.11-4.103 16.75-4.103h46.428l21.157-104.927c1.176-5.862 3.87-10.454 8.081-13.775C206.518 31.66 211.562 30 217.44 30h23.509l-24.684 123.685h72.581L313.53 30h23.214c4.898 0 8.963 1.465 12.195 4.396 3.232 2.931 4.849 6.741 4.849 11.43 0 1.564-.098 2.834-.294 3.811l-21.451 104.048h62.296l-3.82 21.981c-.98 5.667-3.281 9.819-6.905 12.457-3.625 2.638-9.159 3.957-16.603 3.957h-40.552l-19.1 95.547h52.6c4.701 0 8.325 1.124 10.872 3.37 2.547 2.248 3.82 6.205 3.82 11.871 0 .977-.049 2.003-.147 3.078a45.595 45.595 0 01-.44 3.37l-2.645 16.706h-69.643zM191.58 287.627h72.58l19.101-95.547h-72.581l-19.1 95.547z",
    style: {
      mixBlendMode: "darken"
    }
  }));
}

var _default = NumberSign;
exports["default"] = _default;